import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import Index from '@/views/Index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home/index'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children:[
        {
          path: 'index',
          name: 'Index',
          component: Index
        },
        {
          path: 'about',
          name: 'About',
          component: () => import('@/views/About'),
          props: route => ({ hash: route.hash })
        },
        {
          path: 'yulin/:sceneIndex',
          name: 'Yulin',
          component: () => import('@/views/Yulin')
        },
        {
          path: 'product',
          name: 'Product',
          component: () => import('@/views/Product')
        },
        {
          path: 'core',
          name: 'Core',
          component: () => import('@/views/Core')
        },
        {
          path: 'news',
          name: 'News',
          component: () => import('@/views/News')
        },
        {
          path: 'join',
          name: 'Join',
          component: () => import('@/views/Join')
        }
      ]
    },

    // 404页面
    {
      path: '*',
      component: () => import('@/components/Error')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js